import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';
import useSEO from '../hooks/useSEO';

const NotFound = () => {
  // SEO dinâmico para página 404
  useSEO({
    title: '404 - Página não encontrada',
    description: 'Página não encontrada',
    canonical: '/404',
    noindex: true
  });

  return (
    <div className="min-h-screen flex items-center justify-center bg-background-light dark:bg-background-dark px-4">
      <div className="text-center max-w-md w-full">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-light dark:text-primary-dark mb-4">
            404
          </h1>
          <h2 className="text-3xl font-semibold text-foreground-light dark:text-foreground-dark mb-4">
            Página não encontrada
          </h2>
          <p className="text-muted-light dark:text-muted-dark mb-8">
            Desculpe, a página que você está procurando não existe ou foi movida.
          </p>
        </div>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-light dark:bg-primary-dark text-white rounded-lg hover:bg-primary-light/90 dark:hover:bg-primary-dark/90 transition-colors font-medium"
          >
            <Home className="w-5 h-5" />
            Voltar para o Início
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-card-light dark:bg-card-dark text-foreground-light dark:text-foreground-dark rounded-lg hover:bg-card-light/80 dark:hover:bg-card-dark/80 transition-colors font-medium border border-border-light dark:border-border-dark"
          >
            <ArrowLeft className="w-5 h-5" />
            Voltar
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
